import challengesCover from "@/assets/cover/challenges_elgiganten_cover.webp";
import newsCover from "@/assets/cover/news_wog.webp";

import favicon from "../assets/elgiganten/favicon/android-chrome-512x512.png";
import ElgigantenSmall from "../assets/elgiganten/elgiganten_sm.svg";
import ElgigantenLogo from "../assets/elgiganten/elgiganten.svg";

export const Elgiganten_brandVariables = {
  siteTitle: "Elgiganten",
  siteIcon: favicon,
  name: "Elgiganten",
  name_small: "Elgiganten",
  logos: {
    large: ElgigantenLogo,
    white: ElgigantenLogo,
    small: ElgigantenLogo,
    medium: null,
    alt_text: "Elgiganten logo",
    profile: ElgigantenSmall,
  },

  cover: {
    challenges: challengesCover,
    news: newsCover,
    zones: newsCover,
  },

  tenantId: "elgiganten-9u2oj",
  brandTheme: "elgiganten", // Theme of the brand
  site: "elgiganten.iplay.dk", // Live url of site
  authMethod: "email", // Only needed for events, gives user set options to manualy sign up, options are:  email | phone
  defaultCountryCode: "DK", // Only needed for retail platforms | For initial phone number | Changes all auth methods`
  defaultLanguage: "en",
  brandStoreExtension: "", // Only needed for retail platforms | Extension used for email
  brandValue: "ELGIGANTEN", // Only needed for retail platforms | Brand value needed for BE related functions
  brandIntials: "", // gets added after the username, to drasticaly descrease chance of duplicate usernames across different apps | Only needed for event platforms
  defaultNavigateUrl: "/",
  eventHasAutoQrSignup: false,
  hasSubClients: true,
  subClientsForOverviews: [""], // string[] of clients used to fetch multiple types of clients for overview pages
  autoJoinChallenge: true,
  hasFeature: {
    notifications: false,
    themes: false,
    connections: false,
    achievements: false,
    quickSignUp: false,
    messages: false,
    teams: false,
    news: false,
    challenges: true,
    singleChallenge: true,
    preferences: false,
    friends: false,
    zones: false,
    feed: true,
    posts: false,
    winners: false,
    qrSignUp: true,
    manualSubmissions: false,
    landing: true,
    login: true,
    haslanguagePicker: true,
    getstarted: false,
    hero: false,
    search: false,
    routes: true,
    dailytasks: false,
    games: false,
    treasure_hunt: false,
    activities: false,
    changePassword: false,
    feedback: false,
    events: false,
    precisionGame: true,
  },

  hasAuth: {
    steam: false,
    bnet: false,
    quickSignUp: true,
    google: false,
    discord: true,
    twitch: false,
  },

  layout: {
    challenge: "event",
  },

  event: {
    forcedCredentialPopup: "",
    eventCode: "livestream", // Only needed for event platforms
    collectionForSubmissions: "",
    documentForSubmissions: "",
    isEvent: true,
    spacecoins_redirect: true,
  },

  hasCreate: {
    studio: false,
    challenges: false,
    news: false,
  },
};
